'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _Select=require('./Select');Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Select).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/Select/index.js
// module id = 624
// module chunks = 162